import React from 'react';

import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import TextHeaderStyles from './TextHeader.module.scss';
import { ITextHeader } from './TextHeader.types';

const TextHeader = ({ data, level, variant }: ITextHeader) => {
  const type = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
  };
  const Heading = type[level as keyof typeof type] || type[1];

  return (
    <div
      className={classNames(TextHeaderStyles.textHeaderElement, {
        [TextHeaderStyles[`textHeader_${variant}`]]: variant,
      })}
    >
      {Heading && React.createElement(Heading, null, data?.title)}
      {data?.description &&
        data?.description.map((item, index) => (
          <ReactMarkdown key={index} rehypePlugins={[rehypeRaw]}>
            {item}
          </ReactMarkdown>
        ))}
    </div>
  );
};

export default TextHeader;
